import produce from "immer";
import isEqual from "lodash/isEqual";
import { CustomizationState } from "../";
import { Content } from "../../../types/customization/content";

export interface UndoRedo {
  redoStack: Content[];
  undoStack: Content[];
  lastUndoKey: string | undefined;
}

export interface UndoRedoAction {
  type: "undoRedo";
  way: "undo" | "redo" | "reinitialize";
}

export function undoRedo(state: CustomizationState, action: UndoRedoAction): CustomizationState {
  return produce(state, (draftState) => {
    const { way } = action;

    if (way === "undo") {
      const oldContent = draftState.undoRedo.undoStack.pop();
      if (oldContent) {
        draftState.undoRedo.redoStack.push(draftState.content);
        draftState.content = oldContent;
      }
      draftState.undoRedo.lastUndoKey = undefined;

      return;
    }

    if (way === "redo") {
      const oldContent = draftState.undoRedo.redoStack.pop();
      if (oldContent) {
        draftState.undoRedo.undoStack.push(draftState.content);
        draftState.content = oldContent;
      }

      return;
    }

    if (way === "reinitialize") {
      draftState.undoRedo.undoStack = [];
      draftState.undoRedo.redoStack = [];

      return;
    }
  });
}

const MAX_UNDO_CONTENTS = 100;

export function savingForUndo(
  prevState: CustomizationState,
  nextState: CustomizationState,
  undoKey: string | undefined
): CustomizationState {
  if (isEqual(prevState.content, nextState.content)) {
    return nextState;
  }

  return produce(nextState, (draftState) => {
    if (undoKey === "ignore") {
      return;
    }

    if (undoKey === undefined || undoKey !== draftState.undoRedo.lastUndoKey) {
      draftState.undoRedo.undoStack.push(prevState.content);
    }

    if (draftState.undoRedo.undoStack.length > MAX_UNDO_CONTENTS) {
      draftState.undoRedo.undoStack.splice(
        0,
        draftState.undoRedo.undoStack.length - MAX_UNDO_CONTENTS
      );
    }
    draftState.undoRedo.redoStack = [];

    draftState.undoRedo.lastUndoKey = undoKey;
  });
}
